<template>
    <div v-show="show" class="libraryMaterialImgList-container">
        <div class="dialogContent">
            <img @click="cancel" class="close" src="./assets/close.png" alt="">
            <div class="head-container">
                <div class="title">选择素材</div>
            </div>

            <ul ref="listContainer" class="list-container">
                <li @click="handleSelect(item)" v-for="item in list" :key="item.id">
                    <div class="content">
                        <div :class="{select: true, on: item.selected}"></div>
                        <img :src="item.url" alt="">
                        <div class="info">
                            <div class="t">{{item.title}}</div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="foot-container">
                <div class="btns">
                    <div @click="confirm" class="btn g">下一步</div>
                    <div @click="cancel" class="btn">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { Switch, cascader } from 'element-ui'
import { apis } from "@common/config";
import common from "@common/common";
export default {
    components: {
        DatePicker,
        'el-switch': Switch,
        'el-cascader': cascader
    },
    computed: {
        selectText() {
            return this.list.filter(item => item.selected).map(item => item.title).join('、');
        }
    },
    data() {
        let that = this;
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '清空选择',
                    onClick(picker) {
                        const end = '';
                        const start = '';
                        picker.$emit('pick', [start, end]);
                        that.pageIndex = 1;
                        that.getSourceDocList();
                    }
                }]
            },
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '退回理由',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空',
            times: "1",
            date: "15",
            priority: '',
            isCycle: false,
            datePicker: '',
            props: { 
                multiple: true,
                label: 'title',
                value: 'id',
                lazy: true,
                lazyLoad(node, resolve) {
                    console.log(123123)
                    const { level } = node;
                    if(!node.value) return
                    that.getSourceList(node.value,resolve)
                }
             },
            options: [],
            dateValue: [],
            list: [],
            pageIndex: 1,
            loading: false,
            keyword: '',
            saveOptions: [],
            source_info: []
        }
    },
    methods: {
        handleSelect(item) {
            console.log(item)
            this.list.forEach(el => {
                if(el.id != item.id){
                    el.selected = false;
                }
            })
            item.selected = !item.selected;
        },
        changeSource(val) {
            // 遍历选中的值，构建结果数组
            const result = [];
            val.forEach(item => {
                if (Array.isArray(item)) {
                    const id = item[item.length - 1];
                    // 在 saveOptions 中查找 ID 的位置
                    const found = this.findIdInSaveOptions(this.saveOptions, id);
                    if (found) {
                        if (found.pid === null) {
                            // 如果在第一层
                            result.push({"pid": id, "sid": "", "source_type": "0"});
                        } else {
                            // 如果在 children 数组中
                            result.push({"pid": found.pid, "sid": id, "source_type": "0"});
                        }
                    }
                }
            });

            this.source_info = result;

            this.pageIndex = 1;
            this.getSourceDocList();
            // console.log('Result:', result);
        },
        findIdInSaveOptions(options, id, parentId = null) {
            // 递归查找 ID 在 saveOptions 中的位置
            for (let option of options) {
                if (option.id === id) {
                    return { pid: parentId };
                }
                if (option.children && option.children.length > 0) {
                    const found = this.findIdInSaveOptions(option.children, id, option.id);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        },
        getSourceList(source_id = '',resolve) {
            let data = {
                folder_id: this.config ? this.config.folder_id : 1,
                folder_type: 1,
                source_type: 0,
                source_id: source_id
            }
            common.myFetch(apis.sourceList,data).then(res => {
                console.log(res)
                if (res) {
                    if (source_id) {
                        // 如果有 source_id，将数据作为 children 添加到对应节点
                        this.addChildrenToNode(this.saveOptions, source_id, res);
                        
                        // 如果有 resolve，调用 resolve
                        if (resolve) {
                            resolve(
                                (res || []).map((item) => {
                                    return {
                                        title: item.title,
                                        id: item.id,
                                        source_type: 0,
                                        leaf: true,
                                    };
                                })
                            );
                        }
                    } else {
                        this.saveOptions = res;
                        // 如果没有 source_id，直接更新 options
                        this.options = res;
                    }
                }
            }).catch(err => {
                console.error('Failed to get source list:', err);
                if (resolve) {
                    resolve([]);
                }
            })
        },
        addChildrenToNode(nodes, source_id, children) {
            // 递归查找节点并添加 children
            for (let node of nodes) {
                if (node.id === source_id) {
                    // 找到节点，添加 children
                    node.children = children.map(item => ({
                        title: item.title,
                        id: item.id,
                        source_type: 0,
                        pid: source_id
                    }));
                    return true;
                }
                
                // 如果节点有 children，递归查找
                if (node.children && node.children.length > 0) {
                    if (this.addChildrenToNode(node.children, source_id, children)) {
                        return true;
                    }
                }
            }
            return false;
        },
        getSourceDocList() {
            this.loading = true;
            let data = {
                folder_id: this.config.folder_id,
                time_start: this.dateValue && this.dateValue.length == 2 ? this.dateValue[0] : '',
                time_end: this.dateValue && this.dateValue.length == 2 ? this.dateValue[1] : '',
                keyword: this.keyword,
                from_req: 1,
                page: this.pageIndex,
                source_info: JSON.stringify(this.source_info)
            }
            common.myFetch(apis.sourceDocList,data).then(res => {
                console.log(res)
                if (res) {
                    res.list.forEach(el => {
                        el.selected = false;
                    });
                    if (this.pageIndex === 1) {
                        this.list = res.list;
                    } else {
                        this.list = this.list.concat(res.list);
                    }
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            // 将 lazyLoadHandler 方法赋值给 props.lazyLoad
            // this.getSourceList()
            // this.getSourceDocList()
            config.forEach(item => {
                item.selected = false;
            })
            this.list = JSON.parse(JSON.stringify(config))
            this.show = true;
        },
        confirm() {
            let id = ''
            let obj = {}
            this.list.forEach(item => {
                if(item.selected){
                    id = item.id
                    obj = item
                }
            })

            if(!id){
                this.$message.error('请选择内容')
                return
            }else{
                this.show = false;
                this.callback(obj)
            }
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        async close() {
            this.show = false;
        },
        sourceClick() {
            this.$refs.sourceCascader.$el.click()
        },
        timeClick() {
            this.$refs.timePickerCascader.$el.click()
        },
        handleScroll() {
            const container = this.$refs.listContainer;
            if (!container) return;
            
            const { scrollTop, scrollHeight, clientHeight } = container;
            
            // 当滚动到距离底部20px时触发加载
            if (scrollTop + clientHeight >= scrollHeight - 20 && !this.loading) {
                this.pageIndex++;
                this.getSourceDocList();
            }
        }
    },
    mounted() {
       
    },
    beforeDestroy() {
        
    }
}
</script>

<style lang="less">
    .libraryMaterialImgList-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .dialogContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 880px;
            height: 620px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            box-sizing: border-box;

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 18px;
                height: 18px;
                user-select: none;
                cursor: pointer;
            }

            .head-container {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 72px;
                padding: 0 88px 0 30px;
                box-sizing: border-box;

                .title {
                    font-weight: bold;
                    font-size: 24px;
                    color: #050F0F;
                    line-height: 33px;
                }

                .search {
                    display: flex;
                    align-items: center;
                    padding: 0 20px;
                    width: 300px;
                    height: 40px;
                    background: rgba(185,195,195,0.2);
                    border-radius: 20px;
                    box-sizing: border-box;

                    input {
                        width: 500px;
                        height: 32px;
                        background: transparent;
                        border: none;

                        &::placeholder {
                            color: #B9C3C3;
                        }
                    }

                    i.searchIcon {
                        width: 16px;
                        height: 16px;
                        min-width: 16px;
                        background: url('./assets/search.png') no-repeat;
                        background-size: 100% 100%;
                        background-position: center;
                        cursor: pointer;
                        margin-left: 10px;
                        user-select: none;
                    }
                }
            }

            .filter-container {
                display: flex;
                align-items: center;
                width: 100%;
                height: 30px;
                background: rgba(185, 195, 195, 0.2);
                padding: 0 30px;
                box-sizing: border-box;
                margin-bottom: 9px;

                .source {
                    position: relative;
                    display: flex;
                    align-items: center;

                    .btn {
                        display: flex;
                        align-items: center;
                        user-select: none;
                        cursor: pointer;

                        p {
                            font-weight: bold;
                            font-size: 14px;
                            color: #829191;
                        }

                        i {
                            width: 8px;
                            height: 4px;
                            min-width: 8px;
                            background: url('./assets/arrow.png') no-repeat;
                            background-size: 100% 100%;
                            background-position: center;
                            cursor: pointer;
                            margin-left: 10px;
                            user-select: none;
                        }
                    }

                    .sourceCascader {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 0 !important;
                        height: 30px;
                        overflow: hidden;

                        input {
                            padding: 0 !important;
                            border: none;
                        }

                        .el-input__suffix {
                            display: none;
                        }
                    }
                }

                .time {
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-left: 50px;
                    cursor: pointer;
                    user-select: none;

                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #829191;
                    }

                    i {
                        width: 8px;
                        height: 4px;
                        min-width: 8px;
                        background: url('./assets/arrow.png') no-repeat;
                        background-size: 100% 100%;
                        background-position: center;
                        cursor: pointer;
                        margin-left: 10px;
                        user-select: none;
                    }

                    .timePickerCascader {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 0 !important;
                        height: 30px !important;
                        overflow: hidden;
                        padding: 0 !important;
                        border: none;
                    }
                }
            }

            .list-container {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 0;
                width: 100%;
                overflow-y: auto;

                li {
                    width: 100%;
                    height: 120px;
                    padding: 0 30px;
                    box-sizing: border-box;

                    &:hover {
                        background: rgba(185,195,195,0.15);
                    }

                    .content {
                        display: flex;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        .select {
                            width: 16px;
                            height: 16px;
                            border-radius: 2px;
                            border: 1px solid #B9C3C3;
                            margin-right: 20px;
                            user-select: none;
                            cursor: pointer;

                            &.on {
                                background: url('./assets/selected.png') no-repeat;
                                background-size: 100% 100%;
                                background-position: center;
                                border: none;
                            }
                        }

                        img {
                            width: 142px;
                            height: 80px;
                            border-radius: 4px;
                            margin-right: 30px;
                            object-fit: contain;
                        }

                        .info {
                            display: flex;
                            align-items: center;
                            flex: 1;
                            min-width: 0;
                            height: 100%;

                            .t {
                                font-weight: bold;
                                font-size: 16px;
                                color: #050F0F;
                                line-height: 22px;
                                margin-bottom: 10px;
                                margin-top: 10px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }

            .foot-container {
                position: relative;
                width: 100%;
                height: 80px;
                background: #F9F9F9;
                box-shadow: 0px 0px 10px 0px rgba(6,21,50,0.05);
                border-radius: 0px 0px 4px 4px;

                .notice {
                    position: absolute;
                    top: 33px;
                    left: 30px;
                    display: flex;
                    width: 238px;

                    span {
                        font-weight: bold;
                        font-size: 14px;
                        color: #829191;
                        white-space: nowrap;
                    }

                    p {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 14px;
                        color: #050F0F;
                    }
                }

                .btns {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;

                    .btn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 120px;
                        height: 32px;
                        background: #B9C3C3;
                        border-radius: 4px;
                        font-weight: bold;
                        font-size: 14px;
                        color: #FFFFFF;
                        user-select: none;
                        cursor: pointer;

                        &.g {
                            background: #41B48C;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }
    }

    .sourceCascaderPoper {
        .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
            color: #41B48C !important;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #41B48C !important;
            border-color: #41B48C !important;
        }

        .el-checkbox__input.is-focus .el-checkbox__inner {
            border-color: #41B48C !important;
        }

        .el-checkbox__inner:hover {
            border-color: #41B48C !important;
        }
    }

    .timePickerPoper {
        .el-picker-panel__shortcut {
            &:hover {
                color: #41B48C !important;
            }
        }
    }
</style>